import { Link } from "react-router-dom";
import "./HeaderCard.css";
import Victor from "assets/Vector.svg";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
const HeaderCard = (homeData) => {

  const { t } = useTranslation("About");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-visible");
          } else {
            entry.target.classList.remove("animate-visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    const sections = document.querySelectorAll(".animate-section");
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);
  return (
    <div className=" w-[90%]  relative mx-auto scale-[98%] "
        // style={
    //   {
    //     backgroundImage:`url(${Victor})`,
    //     backgroundPosition:"-100px,0",
    //     backgroundSize:"80%",
    //     backgroundRepeat:"no-repeat"
    //   }
    // }
    >
      {/* Background Images */}
      <div className="md:pt-20">
<img
 className="relative w-[100%] xl:absolute xl:bottom-[27%] ltr:rotate-y-180 xl:end-[-6rem] xl:w-[75%] animate-section opacity-0 transition-opacity duration-1000"
   src={Victor}
    alt="" />
      {/* Content Section */}
      <div className=" w-full xl:w-[50%] py-10 xl:ms-8 animate-section opacity-0 transition-opacity duration-1000 lg:min-h-[500px] md:min-h-[400px]">
      <div className="flex flex-col gap-5  items-start flex-nowrap">
        <div className="flex flex-col gap-[4px] items-start self-stretch shrink-0 flex-nowrap relative z-[4]">
          <span className=" text-[17px] font-normal leading-[29px] text-[#667680] 29LT_Bukra">
            {t('About')}
          </span>
          <span className="flex  text-[28px] text_bold_Bukra  leading-[54.6px] text-[#0d6b70] md:w-[80%]  ">
          {/* {homeData?.homeData?.data?.sections[0]?.Posts[0]?.title} */}
           {homeData?.homeData?.data?.sections[0]?.Posts[0]?.title}
          </span>
        </div>
        <span className="flex  font-medium text-[1rem] leading-[25px] text-[#667680] md:w-[85%] 29LT_Bukra">
        {homeData?.homeData?.data?.sections[0]?.Posts[0]?.description}
        </span>
      </div>
      <div className="flex"> 
      <Link to={"/aboutus"} className="flex w-44  px-2 py-3 gap-[8px] justify-center items-center rounded-[999px] border-solid border border-[#0d6b70] group hover:bg-[#0d6b70] hover:text-white hover:border-white hover:scale-90 transition-transform duration-300 pointer mt-6">
        <span  className="flex justify-center 29LT_Bukra font-normal items-start shrink-0 basis-auto  text-[14px] text-[#0d6b70] group-hover:text-white leading-[25px]  relative text-center whitespace-nowrap z-[9]">
            {t('view_more')}
        </span>
      </Link>

      </div>

      </div>

      </div>
    </div>
    
  );
};

export default HeaderCard;
